import {useMutation, useQuery} from "@apollo/client";

import {
  GET_PROFILE,
  UPDATE_NOTIFICATION_SETTINGS,
  UPDATE_PROFILE,
  UPDATE_PAYOUT_METHOD,
  NOTIFICATION_SETTINGS,
} from "./gql";

export const useProfile = () => {
  const {data, loading, error} = useQuery(GET_PROFILE, {});
  return {
    data: data?.me,
    loading,
    error,
  };
};

export const useUpdateProfileData = () => {
  const [updateProfile, updateProps] = useMutation(UPDATE_PROFILE, {
    refetchQueries: [{query: GET_PROFILE}],
  });
  const [updateNotificationSettings, updateNotificationSettingsProps] = useMutation(UPDATE_NOTIFICATION_SETTINGS, {
    refetchQueries: [{query: NOTIFICATION_SETTINGS}],
  });
  const [updatePayoutMethod, updatePayoutMethodProps] = useMutation(UPDATE_PAYOUT_METHOD, {
    refetchQueries: [{query: GET_PROFILE}],
  });

  return {
    updateProfile: async (data: any) => {
      //console.log(data);
      const res = await updateProfile({
        variables: {
          input: {
            ...data,
          },
        },
      });
      return res;
    },
    updateNotificationSettings: async (data: any) => {
      const res = await updateNotificationSettings({
        variables: {
          input: {
            ...data,
          },
        },
      });
      return res;
    },
    updatePayoutMethod: async (data: any) => {
      const res = await updatePayoutMethod({
        variables: {
          input: {
            ...data,
          },
        },
      });
      return res;
    },
    loading: updateProps.loading || updateNotificationSettingsProps.loading || updatePayoutMethodProps.loading,
    error: updateProps.error || updateNotificationSettingsProps.error || updatePayoutMethodProps.error,
  };
};

export const useNotificationSettings = () => {
  const {data, loading, error} = useQuery(NOTIFICATION_SETTINGS, {});
  return {
    data: data?.notificationSettings,
    loading,
    error,
  };
};
